export default __webpack_public_path__ + "static/media/thumbs-up.cab7ff69.svg";